import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../hooks/useAuth';
import { Spinner } from 'reactstrap';
import CaseFollowUpAdmin from './CaseFollowUpAdmin';
import CaseFollowUpLawyer from './CaseFollowUpLawyer';

const CaseFollowUp = () => {
  const { hasRole, isLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading) {
      // Si es admin, mostrar vista admin
      if (hasRole('admin')) {
        return;
      }
      // Si es lawyer, mostrar vista lawyer
      if (hasRole('lawyer')) {
        return;
      }
      // Si no tiene ninguno de los roles, redirigir
      navigate(`${process.env.PUBLIC_URL}/dashboard/default`);
    }
  }, [hasRole, isLoading, navigate]);

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
        <Spinner color="primary" />
      </div>
    );
  }

  // Mostrar vista según el rol
  if (hasRole('admin')) {
    return <CaseFollowUpAdmin />;
  }

  if (hasRole('lawyer')) {
    return <CaseFollowUpLawyer />;
  }

  // Si no tiene permisos, no debería llegar aquí por el useEffect
  return null;
};

export default CaseFollowUp;

